import { cleanString, cleanStringRules, useIsMobile } from '@ab-core/functions';
import { Image } from '@ab-core/image';
import { Link } from '@ab-core/link';
import useText from '@ab-core/localization/src/useText';
import type { ModalType } from '@ab-core/modal';
import Modal from '@ab-core/modal';
import Spacer from '@ab-core/spacer';
import Text from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import { CardInfo, Picture } from './styled';
import type { ProductDocument } from '@ab-core/graphql/dist';
import { EXTERNAL_ROUTES } from '@ab-core/functions/routes';

type ItShopModalProps = Pick<ModalType, 'open' | 'onClose'> & Pick<ProductDocument, 'ean'>;

export const ItShopModal: FC<ItShopModalProps> = (props) => {
    const { open, onClose, ean } = props;
    const isMobile = useIsMobile();

    const headline = useText('itshop.headline');
    const text = useText('itshop.text');
    const text1 = useText('itshop.text1');
    const text2 = useText('itshop.text2');
    const bulletPointHeadline = useText('itshop.bulletpointheadline');
    const bulletPoint1 = useText('itshop.bulletpoint1');
    const bulletPoint2 = useText('itshop.bulletpoint2');
    const bulletPoint3 = useText('itshop.bulletpoint3');
    const name = useText('itshop.name');
    const tel = useText('itshop.tel');
    const link1 = useText('itshop.link1');
    const link2 = useText('itshop.link2');

    const cleanTel = cleanString(tel, [cleanStringRules.removeAllWhitespace, cleanStringRules.removeAllHyphens]);

    const getItShopLink = (productEan?: string) => {
        if (!productEan) {
            return EXTERNAL_ROUTES.ITSHOP_LOGIN;
        }

        return `${link1}${productEan}`;
    };

    return (
        <Modal open={open} onClose={onClose} paddingRight={0} headerText={headline}>
            <Spacer size={'xs'} />
            <CardInfo>
                <Picture>
                    <Image
                        src="https://res.cloudinary.com/alexander-buerkle/image/upload/v1659680259/Ansprechpartner.png"
                        objectFit="COVER"
                    />
                </Picture>
                <div className="flex-direction-column">
                    {isMobile && <Spacer size={'sm'} />}
                    <Text content={text} className="pb-small3" />
                    <Text content={bulletPointHeadline} />
                    <Spacer size={'xs'} />
                    <Text content={bulletPoint1} />
                    <Text content={bulletPoint2} />
                    <Text content={bulletPoint3} />
                    <Spacer size={'xs'} />
                    <Text>
                        {text1}{' '}
                        <Link to={getItShopLink(ean)} target="_blank" className="text-color-primary">
                            zum IT-Shop.
                        </Link>
                    </Text>
                    <Spacer size={'xs'} />
                    <Text content={text2} />
                    <Link to={link2} target="_blank" className="text-color-primary">
                        Jetzt registrieren.
                    </Link>
                    <Spacer size={'xs'} />
                    <Text content={name} />
                    <Link to={`tel:${cleanTel}`}>{`Tel. : ${tel}`}</Link>
                    <Spacer size={'xs'} />
                </div>
            </CardInfo>
        </Modal>
    );
};
